<template>
  <div>
    <vxe-modal
      v-model="formVisible"
      title="日期输入框"
      width="300"
      :lock-scroll="false"
      @show="showWindow"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        size="mini"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="50px" label="日期" prop="date">
              <el-date-picker
                v-model="form.date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="50px" label="天数" prop="day">
              <el-input
                v-model="form.day"
                autocomplete="off"
                placeholder="输入"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="buttonContainer">
          <el-button type="primary" size="mini" @click="sure">确认</el-button>
        </div>
        <!-- <el-button>取消</el-button> -->
      </el-form>
    </vxe-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 是否显示
      formVisible: false,
      // 表单数据
      form: {
        date: '',
        day: 1
      },
      // 验证规则
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        day: [
          { required: true, message: '请输入天数', trigger: 'change' },
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            length: 8,
            trigger: 'change'
          },
          { validator: this.validDay, trigger: 'change' }
        ],
      }
    }
  },
  methods: {
    // 打开窗口时
    showWindow() {
      this.form = {
        date: '',
        day: 1
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    // 校验天数大于0
    validDay(rule, value, callback) {
      if (Number(value) <= 0) {
        callback(new Error('天数必须大于0'));
      } else {
        callback()
      }
    },
    sure() {
      this.$refs.form.validate((valuid) => {
        if (valuid) {
          this.form.date = this.ykDateFormat('yyyy-MM-dd', this.form.date)
          this.$emit('sureHandler', this.form)
          this.formVisible = false
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.buttonContainer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}

// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>
